import { render, staticRenderFns } from "./total.vue?vue&type=template&id=6b652519"
import script from "./total.vue?vue&type=script&lang=ts"
export * from "./total.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b652519')) {
      api.createRecord('6b652519', component.options)
    } else {
      api.reload('6b652519', component.options)
    }
    module.hot.accept("./total.vue?vue&type=template&id=6b652519", function () {
      api.rerender('6b652519', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/total.vue"
export default component.exports